import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { AlertTriangle } from "lucide-react";
import type { StockResponseDTO } from "../types/stock.types";
import { getStockConditionLabel } from "../utils/stock.utils";
import { memo } from "react";

interface StockDeleteDialogProps {
  open: boolean;
  loading: boolean;
  stock: StockResponseDTO | null;
  onClose: () => void;
  onConfirm: () => void;
}

export const StockDeleteDialog = memo(function StockDeleteDialog({
  open,
  loading,
  stock,
  onClose,
  onConfirm,
}: StockDeleteDialogProps) {
  if (!stock) return null;

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Excluir Item do Estoque</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir este item do estoque?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="p-4 bg-destructive/10 rounded-md border border-destructive/20">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold">{stock.productName}</p>
                <p className="text-sm text-muted-foreground">
                  Código: {stock.barcode} • Tamanho: {stock.size} • Condição:{" "}
                  {getStockConditionLabel(stock.condition)}
                </p>
                <p className="text-sm text-destructive mt-2">
                  Esta ação não pode ser desfeita!
                </p>
              </div>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Excluindo..." : "Excluir Item"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
